export const disableScroll = (isDisable) => {
  return isDisable
    ? (document.body.style.overflow = "hidden")
    : (document.body.style.overflow = "auto"); //to be updated/removed
};
